/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { lazyWithRetry } from "~/tools";

// Defined in a separate file to allow mocking inside tests due to problems with Suspense loading
export const AutocompleteUi = lazyWithRetry(
  () => import("./AutocompleteUi"),
  "AutocompleteUi"
);
